import React, { createContext, useState, useEffect } from "react";
import {fetchPage} from "../../api";

export const StockContext = createContext();

export const StockProvider = ({ stockSymbol, children }) => {
  const [stockData, setStockData] = useState(null);

  useEffect(() => {
          fetchPage("stockpage", stockSymbol)
      .then(data => {
          const stkPage = JSON.parse(data)
          setStockData(stkPage);
          console.log('STOCK PAGE 2',stkPage);
      })
      .catch((error) => console.error("Error fetching stock data:", error));
  }, [stockSymbol]);

  return (
    <StockContext.Provider value={stockData}>
      {children}
    </StockContext.Provider>
  );
};
